import React from "react";

const ArticleCard = ({ article, onOpenArticle, isHero = false }) => {
    const publishedDate = new Date(article.publishedAt).toLocaleDateString();

    const containerClasses = isHero
        ? "group bg-white dark:bg-slate-900 rounded-3xl shadow-xl overflow-hidden cursor-pointer flex flex-col h-auto border border-gray-200 dark:border-slate-700"
        : "group bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-gray-200 dark:border-slate-700 hover:shadow-xl hover:border-gray-300 dark:hover:border-slate-500 transition-all duration-300 cursor-pointer flex flex-col overflow-hidden";

    const imageContainerClasses = isHero
        ? "h-64 sm:h-80 relative overflow-hidden"
        : "h-44 relative overflow-hidden";

    const textContentClasses = isHero
        ? "p-6 md:p-7 flex flex-col justify-between gap-3"
        : "p-4 flex flex-col justify-between flex-grow gap-2";

    const titleClasses = isHero
        ? "text-2xl md:text-3xl font-extrabold text-gray-900 dark:text-slate-50 leading-snug line-clamp-3"
        : "text-base md:text-lg font-semibold text-gray-900 dark:text-slate-50 line-clamp-2";

    const summaryClasses = isHero
        ? "text-base md:text-lg text-gray-600 dark:text-slate-300 line-clamp-3"
        : "text-sm text-gray-500 dark:text-slate-400 line-clamp-3";

    return (
        <article className={containerClasses} onClick={() => onOpenArticle(article.id)}>
            <div className={imageContainerClasses}>
                <img
                    src={
                        article.imageUrl ||
                        `https://firebasestorage.googleapis.com/v0/b/canada60app.firebasestorage.app/o/ads%2FBriefly.png?alt=media&token=a2a9a627-0ff1-498c-83a3-805b68fcfd11`
                    }
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => {
                        e.currentTarget.src = `https://firebasestorage.googleapis.com/v0/b/canada60app.firebasestorage.app/o/ads%2FBriefly.png?alt=media&token=a2a9a627-0ff1-498c-83a3-805b68fcfd11`;
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent pointer-events-none" />
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-black/70 text-[11px] font-semibold text-white uppercase tracking-wider">
                    {article.topic || "General"}
                </div>
            </div>

            <div className={textContentClasses}>
                <div>
                    <h2 className={titleClasses}>{article.title}</h2>
                    <p className={summaryClasses}>{article.summary}</p>
                </div>
                <div className="mt-2 flex items-center justify-between text-[11px] text-gray-400 dark:text-slate-500">
                    <span className="inline-flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
                        {publishedDate}
                    </span>
                    <span className="truncate max-w-[55%] text-right">
                        Source: <span className="font-medium text-gray-500">{article.sourceName}</span>
                    </span>
                </div>
            </div>
        </article>
    );
};

export default ArticleCard;
